module.exports = __webpack_public_path__ + "img/service.39e7df7a.gif";